import React from "react";
import styled from "@emotion/styled";
import SellOrderSellButton from "./SellOrderSellButton";

const SellOrderBottomButtonContainer = styled.div`
  margin: 40px auto;

  @media (min-height: 700px) {
    margin: unset;
    margin-top: 40px;
    max-width: 285px;
  }

  @media (min-height: 700px) and (max-width: 950px) {
    display: none;
  }
`;

const SellFormDesktopBottomButton = ({
  reduxFormDispatch,
  valid,
  img,
  paypalButtonClass,
  missingInfo
}) => (
  <SellOrderBottomButtonContainer>
    <SellOrderSellButton
      reduxFormDispatch={reduxFormDispatch}
      valid={valid}
      img={img || null}
      paypalButtonClass={paypalButtonClass || null}
      missingInfo={missingInfo}
    />
  </SellOrderBottomButtonContainer>
);

export default SellFormDesktopBottomButton;
